angular.module('ikeweb.spike.measure').factory('measureTopics',

    function() {

        return {
            PHOTO_MEASURE: {
                READY: {
                    name: 'photo.measure.ready'
                },
                UPDATE: {
                    name: 'photo.measure.updated'
                }
            },
            MEASUREMENT: {
                SELECTED: {
                    name: 'measurement.selected'
                }
            },
            NOTE: {
                UPDATE: {
                    name: 'measurement.note.updated'
                }
            }
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measure.topics.js
// module id = 578
// module chunks = 0